import { memo } from 'react';
import { Code } from 'constants/keyboard';
import { useEventListener } from 'hooks/useEventListener';
import { useAppDispatch, setActivePage } from 'modules/Editor/store';
import { PageDirection } from 'modules/Editor/store/pageControlSlice.types';

export const KeyboardShortCut = memo(() => {
  const dispatch = useAppDispatch();

  const onNextPage = () => dispatch(setActivePage({ direction: PageDirection.next }));
  const onPreviousPage = () => dispatch(setActivePage({ direction: PageDirection.previous }));

  const onKeyDown = (e: KeyboardEvent | Event) => {
    const event = e as KeyboardEvent;
    const code = event.code as Code;
    const target = event.target as HTMLElement;

    // ignore keyboard shortcuts inside input elements
    if (target?.tagName === 'INPUT' || target?.tagName === 'TEXTAREA') return;

    switch (code) {
      case Code.ArrowRight:
        onNextPage();
        break;
      case Code.ArrowLeft:
        onPreviousPage();
        break;
    }
  };

  useEventListener('keydown', onKeyDown);

  return <></>;
});

KeyboardShortCut.displayName = 'KeyboardShortCut';
